import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logsService from '../services/logsService';

const LAST_TRACK_KEY = 'lastTrackedPageVisit';
const MIN_TRACK_INTERVAL_MS = 3000;

const HRPageVisitTracker = () => {
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    const trackVisit = async () => {
      if (!isAuthenticated || !user || !['HR', 'HRO'].includes(user.role)) {
        return;
      }

      const currentPath = `${location.pathname}${location.search || ''}`;
      const now = Date.now();

      const lastTrackedRaw = sessionStorage.getItem(LAST_TRACK_KEY);
      if (lastTrackedRaw) {
        try {
          const parsed = JSON.parse(lastTrackedRaw);
          if (parsed.path === currentPath && now - parsed.timestamp < MIN_TRACK_INTERVAL_MS) {
            return;
          }
        } catch (error) {
          // Ignore invalid cache payload
        }
      }

      sessionStorage.setItem(
        LAST_TRACK_KEY,
        JSON.stringify({
          path: currentPath,
          timestamp: now
        })
      );

      try {
        await logsService.trackPageVisit({
          path: currentPath,
          fullUrl: window.location.href,
          pageTitle: document.title
        });
      } catch (error) {
        // Keep tracking failures silent to avoid UI disruption.
      }
    };

    trackVisit();
  }, [isAuthenticated, user, location.pathname, location.search]);

  return null;
};

export default HRPageVisitTracker;
